const TABS = [
  { key: 'stats', label: 'Feedback Stats' },
  { key: 'feedback', label: 'Feedback Details' },
  { key: 'build3', label: 'Build3 Submissions' },
  { key: 'wellness', label: 'Wellness Collaborative' },
  { key: 'cohort', label: 'Build3 Cohorts' },
  { key: 'midDayReset', label: 'Mid Day Reset' },
  { key: 'oneOnOne', label: '1-on-1 Requests' },
  { key: 'spaces', label: 'Spaces' },
  { key: 'events', label: 'Events' },
  { key: 'consultations', label: 'Corporate Consultations' },
  { key: 'facConsultations', label: 'Facilitator Consultations' },
  { key: 'certifications', label: 'Certifications' },
]

const AdminTabNav = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {TABS.map(tab => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
            activeTab === tab.key
              ? 'bg-purple-600 text-white shadow-lg shadow-purple-500/30'
              : 'bg-white/10 text-gray-300 hover:bg-white/20'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default AdminTabNav
